'use client'

import { memo, type JSX } from 'react'

import Image from 'next/image'

import logoIcon from '@images/navbar/logo_main-nav.svg'

import styles from './logo.module.scss'
import Link from 'next/link'

function Logo(): JSX.Element {
  return (
    <Link href="/" className={styles.logo}>
      {/* logo_main-nav.svg is 134x32 (ratio 4.1875); minireset's global `img { height: auto }`
      already renders it at that ratio, so 33 (the old prop) never matched what was on screen and
      Next warned about it. 31 = round(131 / 4.1875), the actual rendered height. [S20-865] */}
      <Image src={logoIcon} alt="SonicJobs Logo" width={131} height={31} />
    </Link>
  )
}

export default memo(Logo)
